export const subscriptionFormContainer =
  'grid float-left gap-y-3 mdS:gap-x-3 mdS:gap-y-2 mdS:grid-cols-2 md:float-none md:grid-cols-2 md:gap-x-4';
export const subscriptionCheckboxContainer = 'relative row-[3] md:col-span-full md:row-[2]';
export const subscriptionFieldContainer = '[&_input]:w-full';
export const subscriptionButton = 'h-11 w-[140px] xl:ml-2 site-paragraph-s mdS:mt-6';
const errorMessageClasses = 'site-paragraph-xs';
const labelClasses = 'site-paragraph-xs';

const footerSubscriptionSiteTheme = {
  subscriptionFormContainer,
  subscriptionCheckboxContainer,
  subscriptionFieldContainer,
  subscriptionButton,
  errorMessageClasses,
  labelClasses,
};

export default footerSubscriptionSiteTheme;
